function parseHashGup(){
	if (window.location.hash != ""){
		return window.location.hash.split('#')[1].split('&').reduce(function(result,item){
	    	result[item.split("=")[0]]=item.split("=")[1];
	    	return result
		},{})
	}else{
		return {}
	}
};


(function($){
	$.fn.customSelect = function(options){
		window.param.gup = parseHashGup();

		// This is the easiest way to have default options.
		var settings = $.extend({
			itemList : [],
			name : "",
			cb : (function(){}),
		}, options );

		var $button = $(this).find('button');
		var $list = $(this).find('ul');
		var $this = $(this);
		// console.log(settings.itemList)

		function changeValue($e){
			_$this = $(this);

			$button.text(_$this.data('text'))
			$button.data('value',_$this.data('value'))
			window.param.gup[settings.name] = _$this.data('value');
			window.location.hash = $.param(window.param.gup);
			settings.cb();
		}

		function initSelect($obj, list){
			var value = "";

			if(settings.name!=""){
				value = parseHashGup()[settings.name];
			}

			list.forEach(function(element, index, array) {
				var vlink = $('<a>').text(element.text).data('value',element.value).data('text',element.text).on('click',changeValue).attr('href', 'javascript:void(0);')
				if (element.value == value){
					$button.text(element.text);
					$button.data('value',element.value)
				}
				$obj.append($('<li>').append(vlink))
			})

		};
		initSelect($list, settings.itemList);

	}
}( jQuery ));
